<script setup>
import SeatComponent from './SeatComponent.vue'
import { computed, } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { store } from '@/store'
import { useRoomStore } from '@/stores/room'
import { getScore } from '@/helpers/getScore'

const roomStore = useRoomStore()

const { getAccessTokenSilently } = useAuth0()
const seatSlotCount = 2

async function onReset() {
  const roomId = store.roomId
  const token = await getAccessTokenSilently()

  await fetch(`${import.meta.env.VITE_BACKEND_BASE_URL}/rooms/${roomId}/reset`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  })
}

async function onReveal() {
  const roomId = store.roomId
  const token = await getAccessTokenSilently()

  await fetch(`${import.meta.env.VITE_BACKEND_BASE_URL}/rooms/${roomId}/reveal`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
  })
}

const seatSlots = computed(() => {
  const slots = Array.from({ length: seatSlotCount }, () => [])
  const usersArray = Object.values(roomStore.users ?? {})
  for (let i = 0; i < usersArray.length; i++) {
    const arrayIndex = i % seatSlotCount
    slots[arrayIndex].push(usersArray[i])
  }
  return slots
})

</script>
<template>
  <div class="flex flex-col h-fit w-fit self-center">
    <div class="flex flex-row justify-evenly my-4 h-28">
      <SeatComponent v-for="user in seatSlots[0]" :key="user.id" :userId="user.id" />
    </div>
    <div>
      <div class="min-h-32 min-w-64 bg-surface-primary rounded-lg">
        <button v-if="roomStore.showRevealButton" @click="onReveal"
          class="h-full w-full min-h-32 min-w-64 bg-surface-active p-4 border-[0.5px] hover:border-2 border-accent rounded-lg text-accent dark:text-neutral">
          Reveal Votes
        </button>

        <button v-if="roomStore.showResetButton" @click="onReset"
        class="h-full w-full min-h-32 min-w-64 bg-surface-active p-4 hover:border-2 hover:border-primary rounded-lg text-accent dark:text-neutral">
          <div class="flex flex-row justify-center items-center text-4xl font-bold">
            {{ getScore(roomStore.round?.votes) }}
          </div>
          Start new Round
        </button>
      </div>
    </div>
    <div class="flex flex-row justify-evenly my-4 h-28">
      <SeatComponent v-for="user in seatSlots[1]" :key="user.id" :userId="user.id" />
    </div>
  </div>
</template>


<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
